export const tabs = ['Urgent', 'Critical', 'Warning']
